import Separator from "@components/CustomTypography/Separator/Separator"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import {SelectedCategories} from "./CareersJobForm"
import CategoriesSelects from "./CategoriesSelects/CategoriesSelects"
import styles from "./MainBox.module.scss"

type Props = {
	categories: CategoryModuleType[]
	selectedCategories: SelectedCategories
	handleCheckboxChange: (title: string, subcategories: string) => void
}

const MainBox = (props: Props) => {
	return (
		<div>
			<div className={styles.box}>
				{props.categories?.map(
					(element: CategoryModuleType, index: number) => {
						return (
							<CategoriesSelects
								key={index}
								element={element}
								selectedCategories={
									props.selectedCategories[element.title]
								}
								onCheckboxChange={(subcategory) =>
									props.handleCheckboxChange(
										element.title,
										subcategory,
									)
								}
							/>
						)
					},
				)}
			</div>

			<Separator size={32} />
		</div>
	)
}

export default MainBox
